/* ==========================================================================
   VPV HEADER (Track B chrome) — custom JS. Loaded after theme.js.
   Phase 1: sticky/transparent behavior, mobile drawer (reuses theme.Drawers),
   and the search reveal (wraps Impulse predictive search). Megamenu disclosure +
   mobile drilldown come in later phases.
   ========================================================================== */
(function () {
  // Listeners on long-lived targets (window / document / matchMedia) are tracked
  // so a re-init (Shopify editor section reload) can remove them first and not
  // stack duplicates. Element-scoped listeners are GC'd with the replaced DOM.
  var teardowns = [];
  function onGlobal(target, type, handler, opts) {
    target.addEventListener(type, handler, opts);
    teardowns.push(function () { target.removeEventListener(type, handler, opts); });
  }
  function teardownGlobals() {
    while (teardowns.length) { teardowns.pop()(); }
  }

  function init() {
    teardownGlobals(); // clear any globals from a previous init (editor reload)
    document.querySelectorAll('vpv-header').forEach(setupHeader);
    setupDrawers();
    setupViewportVars();
    setupOverlay();
    setupSearch();
    setupNav();
    setupResponsiveNav();
    setupDrilldown();
    setupDebug();
    setupStickyAtc();
    setupBisButtonPlacement();
    setupFeatureModal();
  }

  // Product Features modal: each grid cell (.product-feature[data-vpv-feature])
  // teleports the block's hidden accordion into the shared tool-tip panel and
  // deep-links to the clicked feature (data-vpv-feature → the section's data-handle,
  // opened by ToolTip._open). Reuses the fit-guide panel + accordion scaffolding.
  function setupFeatureModal() {
    document.querySelectorAll('.product-block--product-features-grid').forEach(function (grid) {
      var modal = grid.querySelector('[data-vpv-feature-modal]');
      if (!modal) return;
      var accordion = modal.querySelector('[data-vpv-accordion]');
      if (!accordion) return;
      var titleEl = modal.querySelector('[data-vpv-feature-title]');
      grid.querySelectorAll('.product-feature[data-vpv-feature]').forEach(function (btn) {
        onGlobal(btn, 'click', function (event) {
          // Stop the opening click from bubbling to the document, or ToolTip's
          // outside-click handler (attached during _open) fires on this same click
          // and immediately closes the panel — the "boomerang". Mirrors ToolTipTrigger.
          event.stopPropagation();
          document.dispatchEvent(new CustomEvent('tooltip:open', {
            detail: {
              context: 'product-features',
              title: titleEl ? titleEl.innerHTML : 'Product Features',
              content: accordion.outerHTML,
              openSection: btn.getAttribute('data-vpv-feature'),
              el: btn
            }
          }));
        });
      });
    });
  }

  // Mobile sticky Add-to-Cart bar (PDP). The bar's button is a PROXY: it clicks the
  // real .vpv-pdp-atc button, so all variant/cart logic stays in one place. We mirror
  // the real button's label + disabled state onto it, and reveal the bar (.is-visible)
  // once the real button has scrolled up out of view. CSS hides the bar on desktop.
  function setupStickyAtc() {
    var bar = document.querySelector('[data-vpv-sticky-atc]');
    if (!bar) return;
    var stickyBtn = bar.querySelector('[data-vpv-sticky-atc-btn]');
    var stickyLabel = bar.querySelector('[data-vpv-sticky-atc-label]');
    if (!stickyBtn) return;

    // Real ATC button = the [data-add-to-cart] that isn't inside the bar.
    var realBtn = null;
    document.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      if (!realBtn && !bar.contains(b)) realBtn = b;
    });
    if (!realBtn) return;

    // Proxy the tap onto the real button (a disabled <button> won't fire, but guard anyway).
    onGlobal(stickyBtn, 'click', function () {
      if (!stickyBtn.disabled) realBtn.click();
    });

    // Mirror the real button's label + disabled state.
    function sync() {
      var off = realBtn.disabled || realBtn.classList.contains('disabled');
      stickyBtn.disabled = off;
      stickyBtn.classList.toggle('disabled', off);
      var realLabel = realBtn.querySelector('[data-add-to-cart-text]');
      if (realLabel && stickyLabel) stickyLabel.textContent = realLabel.textContent.trim();
    }
    var mo = new MutationObserver(sync);
    mo.observe(realBtn, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true, characterData: true });
    teardowns.push(function () { mo.disconnect(); });
    sync();

    // Reveal once the real button has scrolled ABOVE the viewport (i.e. past it).
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(realBtn);
      teardowns.push(function () { io.disconnect(); });
    }
  }

  // AMP "Back in Stock" notify button (PDP). The app injects its own button, but its
  // placement is driven by an anchor configured in the AMP dashboard — on this theme it
  // lands up by the price instead of by the buy button. We relocate the injected button
  // to sit directly BELOW the real Add-to-Cart wrapper (.vpv-pdp-atc). AMP tags its
  // button with BIS_trigger in one of two forms depending on its render path — either a
  // CLASS (.bis-button/.bis-image .BIS_trigger) or an ID (#BIS_trigger, no class) — and
  // hides any duplicate with inline display:none, so we match both and move the first
  // non-hidden one. Moving the
  // node keeps AMP's own click handler intact. AMP re-renders on variant change, so a
  // MutationObserver + the theme's variant:change event re-apply the move each time.
  function setupBisButtonPlacement() {
    // Real ATC wrapper = the .vpv-pdp-atc holding the [data-add-to-cart] that ISN'T in
    // the sticky bar. If it's absent, we're not on a PDP with the VPV buy button.
    var realBtn = null;
    document.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      if (!realBtn && !b.closest('[data-vpv-sticky-atc]')) realBtn = b;
    });
    if (!realBtn) return;
    var wrapper = realBtn.closest('.vpv-pdp-atc');
    if (!wrapper) return;

    function place() {
      var btns = document.querySelectorAll('.BIS_trigger, #BIS_trigger');
      for (var i = 0; i < btns.length; i++) {
        var btn = btns[i];
        if (btn.style.display === 'none') continue;       // AMP's hidden duplicate
        if (btn.previousElementSibling === wrapper) return; // already in place
        wrapper.insertAdjacentElement('afterend', btn);
        return;
      }
    }

    // Coalesce bursts of mutations (and the mutation our own move triggers) into one
    // placement per frame.
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; place(); });
    }

    var mo = new MutationObserver(schedule);
    mo.observe(document.body, { childList: true, subtree: true });
    teardowns.push(function () { mo.disconnect(); });

    onGlobal(document, 'variant:change', schedule);
    schedule();
  }

  var NAV_MOBILE_MQ = '(max-width: 989px)';

  // Closes any open desktop megamenu panel (DOM-only; used on resize → mobile).
  function resetMegamenu() {
    document.querySelectorAll('[data-vpv-nav-item]').forEach(function (it) {
      it.classList.remove('is-open', 'is-leaving');
      var t = it.querySelector('.vpv-nav-item__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.classList.remove('vpv-nav-open');
  }

  // The nav block tree is rendered ONCE (content_for can't render twice). So we
  // physically relocate the same <nav> into the drawer on mobile and back into
  // the header bar on desktop, driven by a matchMedia breakpoint. CSS keys mobile
  // (drilldown) styling off the #VpvNavDrawer ancestor and desktop (megamenu) off
  // .vpv-header__nav. Re-homing on breakpoint change also resets stuck state, so
  // rotating a tablet can't leave the mobile menu open over a desktop layout.
  function setupResponsiveNav() {
    var nav = document.querySelector('.vpv-header__nav');
    var drawer = document.getElementById('VpvNavDrawer');
    if (!nav || !drawer) return;
    var drawerBody = drawer.querySelector('.vpv-nav-drawer__body');
    var home = nav.parentNode; // .vpv-header__inner
    if (!drawerBody || !home) return;
    var mq = window.matchMedia(NAV_MOBILE_MQ);

    function closeDrawer() {
      // Properly close via theme.Drawers so the body scroll-lock is released.
      if (!drawer.classList.contains('drawer--is-open')) return;
      var closeBtn = drawer.querySelector('.js-drawer-close');
      if (closeBtn) closeBtn.click();
    }

    function toMobile() {
      if (nav.parentNode === drawerBody) return;
      resetMegamenu();
      drawerBody.appendChild(nav);
    }

    function toDesktop() {
      if (nav.parentNode === home) return;
      closeDrawer();
      resetDrilldown();
      var icons = home.querySelector('.vpv-header__icons');
      if (icons) { home.insertBefore(nav, icons); } else { home.appendChild(nav); }
    }

    function apply() { if (mq.matches) { toMobile(); } else { toDesktop(); } }

    apply();
    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
      teardowns.push(function () { mq.removeEventListener('change', apply); });
    } else if (mq.addListener) { // older Safari
      mq.addListener(apply);
      teardowns.push(function () { mq.removeListener(apply); });
    }
  }

  // Reset the mobile drilldown back to the root level.
  function resetDrilldown() {
    var drawer = document.getElementById('VpvNavDrawer');
    if (!drawer) return;
    drawer.classList.remove('vpv-nav-drawer--drilled');
    drawer.querySelectorAll('.vpv-nav-item.is-drilled').forEach(function (it) {
      it.classList.remove('is-drilled');
      var d = it.querySelector('.vpv-nav-item__drill');
      if (d) d.setAttribute('aria-expanded', 'false');
    });
  }

  // Mobile drilldown: a chevron (24×24 hotspot) slides its panel in over the root
  // list as a sub-screen; the back row slides it away. Delegated on the drawer, so
  // it keeps working after the nav is relocated in. Desktop megamenu is untouched
  // (these controls are display:none outside #VpvNavDrawer).
  function setupDrilldown() {
    var drawer = document.getElementById('VpvNavDrawer');
    if (!drawer) return;

    // Drill an item's panel in as a sub-screen. Shared by the chevron hotspot and a
    // linkless label tap. Only one panel drilled at a time — clear any other first.
    function drillInto(item) {
      drawer.querySelectorAll('.vpv-nav-item.is-drilled').forEach(function (it) {
        if (it === item) return;
        it.classList.remove('is-drilled');
        var od = it.querySelector('.vpv-nav-item__drill');
        if (od) od.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('is-drilled');
      drawer.classList.add('vpv-nav-drawer--drilled');
      var itemDrill = item.querySelector('.vpv-nav-item__drill');
      if (itemDrill) itemDrill.setAttribute('aria-expanded', 'true');
      var back = item.querySelector('.vpv-nav-panel__back');
      // preventScroll: focusing a mid-slide panel control would otherwise scroll
      // the drawer body sideways (overflow:hidden is still focus-scrollable).
      if (back) back.focus({ preventScroll: true });
    }

    drawer.addEventListener('click', function (e) {
      var drill = e.target.closest('.vpv-nav-item__drill');
      if (drill) {
        e.preventDefault();
        var item = drill.closest('[data-vpv-nav-item]');
        if (item) drillInto(item);
        return;
      }

      // A linkless top-level label renders as a <button> (no URL to navigate to), so
      // tapping the word should drill in just like its chevron. Linked labels stay an
      // <a> and navigate normally, so only <button> triggers are intercepted here.
      var trigger = e.target.closest('.vpv-nav-item__trigger');
      if (trigger && trigger.tagName === 'BUTTON') {
        var titem = trigger.closest('[data-vpv-nav-item]');
        if (titem && titem.querySelector('.vpv-nav-item__drill')) {
          e.preventDefault();
          drillInto(titem);
          return;
        }
      }

      var back = e.target.closest('.vpv-nav-panel__back');
      if (back) {
        e.preventDefault();
        var drilled = back.closest('[data-vpv-nav-item]');
        if (drilled) {
          drilled.classList.remove('is-drilled');
          var d = drilled.querySelector('.vpv-nav-item__drill');
          if (d) { d.setAttribute('aria-expanded', 'false'); d.focus({ preventScroll: true }); }
        }
        if (!drawer.querySelector('.vpv-nav-item.is-drilled')) {
          drawer.classList.remove('vpv-nav-drawer--drilled');
        }
        return;
      }

      // Closing the whole drawer (X): reset to root so it reopens at the top level.
      if (e.target.closest('.js-drawer-close')) {
        setTimeout(resetDrilldown, 350);
      }
    });

    // Reset to root on every open — covers closing via overlay/ESC (which don't
    // hit the close-button branch above), so a stale drilled panel never persists.
    document.querySelectorAll('.js-drawer-open-vpv-nav').forEach(function (btn) {
      btn.addEventListener('click', resetDrilldown);
    });
  }

  // Desktop megamenu. JS owns open/close state via an `.is-open` class so we can
  // add a close-intent delay: leaving an item schedules a close ~150ms out, and
  // entering any item (or re-entering) cancels it. That absorbs the dead space
  // between triggers and the trigger→panel gap, so sweeping across the bar
  // switches the active panel instead of flashing closed-then-open.
  var NAV_CLOSE_DELAY = 300;
  var NAV_LEAVE_MS = 420; // must outlast the is-leaving fade (0.2s delay + 0.2s)

  function setupNav() {
    var items = document.querySelectorAll('[data-vpv-nav-item]');
    if (!items.length) return;

    var closeTimer = null;

    function setAria(item, expanded) {
      var trigger = item.querySelector('.vpv-nav-item__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    function openItem(item) {
      // Desktop megamenu only — when relocated into the mobile drawer, the
      // drilldown (Phase 3) owns interaction, not the hover/focus panels.
      if (item.closest('#VpvNavDrawer')) return;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      items.forEach(function (it) {
        if (it === item) return;
        if (it.classList.contains('is-open')) {
          // Hand-off: hold this panel opaque, then fade it out beneath the
          // incoming one (.is-leaving), so there's no half-faded gap.
          it.classList.remove('is-open');
          it.classList.add('is-leaving');
          setTimeout(function () { it.classList.remove('is-leaving'); }, NAV_LEAVE_MS);
        } else {
          it.classList.remove('is-open', 'is-leaving');
        }
        setAria(it, false);
      });
      item.classList.remove('is-leaving');
      item.classList.add('is-open');
      setAria(item, true);
      document.documentElement.classList.add('vpv-nav-open');
    }

    function closeAll() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      // Final close (mouse left the nav): plain fade-out, no hand-off hold.
      items.forEach(function (it) {
        it.classList.remove('is-open', 'is-leaving');
        setAria(it, false);
      });
      document.documentElement.classList.remove('vpv-nav-open');
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, NAV_CLOSE_DELAY);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', scheduleClose);
      // Keyboard: focus entering an item opens it immediately; focus leaving the
      // nav entirely schedules the same delayed close (tabbing to a sibling
      // cancels it via that item's focusin).
      item.addEventListener('focusin', function () { openItem(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) scheduleClose();
      });
    });

    onGlobal(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!document.documentElement.classList.contains('vpv-nav-open')) return;
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur();
      }
      closeAll();
    });
  }

  function setupHeader(wrapper) {
    var header = wrapper.querySelector('.vpv-header');
    if (!header) return;

    var isSticky = wrapper.dataset.sticky === 'true';
    var isTransparent = wrapper.dataset.transparent === 'true';

    // Solid sticky: reserve the header's height on the wrapper so that switching
    // to position:fixed (when stuck) doesn't make the page jump. Transparent
    // headers are out of flow already, so they need no spacer.
    function reserveSpace() {
      if (isSticky && !isTransparent) {
        wrapper.style.minHeight = header.offsetHeight + 'px';
      }
    }

    if (isSticky) {
      // Detect the stuck state with an IntersectionObserver sentinel rather than a
      // scroll listener. iOS Safari can defer/drop `scroll` events during a
      // downward momentum fling, so a scroll-driven toggle only catches up on the
      // way back UP — the header fails to pin while scrolling down and at rest. IO
      // is compositor-driven and fires reliably regardless of scroll-event timing.
      // The sentinel marks the top of the header area (which sits in flow right
      // after the announcement bar); when it scrolls out of view the header has
      // reached the top of the viewport → stick it.
      var sentinel = document.createElement('div');
      sentinel.className = 'vpv-header__sticky-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;pointer-events:none;';
      wrapper.insertBefore(sentinel, wrapper.firstChild);

      // The IO only toggles the `is-stuck` class. The stuck header's `top` is
      // driven by the shared --vpv-vv-top CSS variable (see setupViewportVars),
      // which corrects for the iOS address-bar / visual-viewport offset.
      var io = new IntersectionObserver(function (entries) {
        header.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(sentinel);
      teardowns.push(function () { io.disconnect(); sentinel.remove(); });
    }

    reserveSpace();
    onGlobal(window, 'resize', reserveSpace, { passive: true });
  }


  // Reuse Impulse's drawers. Impulse instantiates these inside its HeaderSection
  // init (data-section-type="header"), which we replaced — so we instantiate them.
  function setupDrawers() {
    if (!window.theme) return;
    // Mobile nav drawer (generic Drawers: focus trap / scroll lock / ESC / click-outside).
    if (window.theme.Drawers && document.getElementById('VpvNavDrawer')) {
      try { new window.theme.Drawers('VpvNavDrawer', 'vpv-nav'); } catch (e) { /* unavailable */ }
    }
    // Cart drawer (binds .js-drawer-open-cart + cart:open).
    if (window.theme.CartDrawer && document.getElementById('CartDrawer')) {
      try { new window.theme.CartDrawer(); } catch (e) { /* unavailable */ }
    }
    // Announcement bar slideshow (Flickity autoplay between messages). Impulse
    // kicks this off in the same HeaderSection onLoad we replaced, so it never
    // ran — only the first slide showed. Start it here.
    if (window.theme.announcementBar && document.getElementById('AnnouncementSlider')) {
      try { window.theme.announcementBar.init(); } catch (e) { /* unavailable */ }
    }
  }

  // ===== Overlay system. The robust way to do full-screen iOS overlays (proven
  // by the spike across every state/platform): portal the overlay to <body> so
  // `position: fixed` is viewport-relative again (escapes Impulse's transformed
  // page wrapper), and body-pin the page on open. Then CSS `top:0; bottom:0`
  // fills the viewport and reactively tracks the iOS toolbar — no height
  // measurement, no lvh/dvh, no per-state code. The body-pin also IS the scroll
  // lock. Reused by the nav drawer now; cart + search next.
  var overlayScrollY = 0;
  var overlayLockCount = 0;
  function lockPage() {
    if (overlayLockCount === 0) {
      overlayScrollY = window.pageYOffset || 0;
      var b = document.body;
      b.style.position = 'fixed';
      b.style.top = -overlayScrollY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
      document.documentElement.classList.add('vpv-overlay-open');
    }
    overlayLockCount++;
  }
  function unlockPage() {
    overlayLockCount = Math.max(0, overlayLockCount - 1);
    if (overlayLockCount === 0) {
      var b = document.body;
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      // Snap the page back to where it was. <html> has scroll-behavior:smooth
      // (for anchor links), which would otherwise ANIMATE this restore — the page
      // visibly jumps to the top and then smooth-scrolls back down. Neutralise
      // scroll-behavior just for this call so the restore is instant.
      var root = document.documentElement;
      root.classList.remove('vpv-overlay-open');
      var prevScrollBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      window.scrollTo(0, overlayScrollY);
      root.style.scrollBehavior = prevScrollBehavior;
    }
  }
  function setupOverlay() {
    // One shared full-screen dim, body-level so it stacks correctly with the
    // body-level overlays under the body-pin (the old html::after dim stacks
    // wrong once <body> is a fixed stacking context). Reuse on re-init.
    if (!document.querySelector('.vpv-overlay-dim')) {
      var dim = document.createElement('div');
      dim.className = 'vpv-overlay-dim';
      dim.setAttribute('aria-hidden', 'true');
      document.body.appendChild(dim);
    }
    // Portal the nav drawer to <body> (once) and lock on open.
    var navDrawer = document.getElementById('VpvNavDrawer');
    if (navDrawer && navDrawer.parentNode !== document.body) {
      document.body.appendChild(navDrawer);
    }
    onGlobal(document, 'drawerOpen.VpvNavDrawer', lockPage);
    onGlobal(document, 'drawerClose.VpvNavDrawer', unlockPage);
    // Cart drawer: same portal + body-pin. Impulse renders it inside the
    // transformed section wrapper too, so position:fixed needs the same escape.
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer && cartDrawer.parentNode !== document.body) {
      document.body.appendChild(cartDrawer);
    }
    onGlobal(document, 'drawerOpen.CartDrawer', lockPage);
    onGlobal(document, 'drawerClose.CartDrawer', unlockPage);
    // Tool-tip modal (PDP size guide, etc.): same treatment so it slides in from
    // the right and sits above everything like the cart. The <tool-tip> host is
    // rendered at body level already; portal defensively in case that changes.
    // theme.js's ToolTip dispatches these on open/close.
    var toolTip = document.querySelector('tool-tip');
    if (toolTip && toolTip.parentNode !== document.body) {
      document.body.appendChild(toolTip);
    }
    onGlobal(document, 'drawerOpen.ToolTip', lockPage);
    onGlobal(document, 'drawerClose.ToolTip', unlockPage);
    // VPV Collection filter panel: Impulse's Drawers drives open/close + dispatches
    // these events; we add the iOS-safe body-pin lock + shared dim. NOT portaled to
    // <body> (approach A) — the panel stays inside #CollectionAjaxContent so the AJAX
    // section-swap re-renders its counts for free; .main-content establishes no
    // stacking context, so the panel's escalated z-index still clears the header.
    // Gated on the .vpv-filter-panel class so the LEGACY #FilterDrawer on the other
    // collection templates (main-collection) is left completely alone.
    onGlobal(document, 'drawerOpen.FilterDrawer', function () {
      var d = document.getElementById('FilterDrawer');
      if (d && d.classList.contains('vpv-filter-panel')) lockPage();
    });
    onGlobal(document, 'drawerClose.FilterDrawer', function () {
      var d = document.getElementById('FilterDrawer');
      if (d && d.classList.contains('vpv-filter-panel')) unlockPage();
    });
  }

  // Single source of truth for the iOS visual-viewport offset. iOS Safari pins
  // `position: fixed` to the LAYOUT viewport, which sits above the VISUAL viewport
  // by the address-bar height once the bar collapses — so fixed `top: 0` chrome
  // (sticky header, nav drawer, cart drawer) hides above the visible top / leaves
  // a bottom gap. We publish ONE CSS variable on <html> for the STICKY HEADER:
  //   --vpv-vv-top : visualViewport.offsetTop, CLAMPED to the live address-bar gap
  //                  (innerHeight minus visual height). The clamp guards against an
  //                  upward fling, where iOS reports a transient huge offsetTop that
  //                  would otherwise float the header to mid-screen until the scroll
  //                  settles. (The overlays no longer consume vv vars — they portal
  //                  to <body> + body-pin + CSS top:0/bottom:0, no measuring.)
  // No-op where visualViewport is absent (older / desktop): the var() fallback (0) applies.
  function setupViewportVars() {
    var vv = window.visualViewport;
    if (!vv) return;
    var root = document.documentElement;
    function update() {
      var off = Math.max(vv.offsetTop, 0);
      var gap = Math.max(0, window.innerHeight - vv.height);
      root.style.setProperty('--vpv-vv-top', Math.min(off, gap) + 'px'); // header sticky pin (clamped)
    }
    update();
    onGlobal(vv, 'scroll', update, { passive: true });
    onGlobal(vv, 'resize', update, { passive: true });
    // Re-measure on ANY viewport change, not just scroll — covers orientation
    // changes and window resizes on every device (phones, tablets, split-view).
    // iOS reports stale dimensions immediately after `orientationchange`, so
    // re-run a few times as they settle.
    onGlobal(window, 'resize', update, { passive: true });
    onGlobal(window, 'orientationchange', function () {
      update();
      window.setTimeout(update, 100);
      window.setTimeout(update, 300);
      window.setTimeout(update, 600);
    }, { passive: true });
  }

  // TEMPORARY diagnostic overlay (remove after iOS QA). Gated behind the URL flag
  // `?vpvdebug=1` so it never shows in normal QA. Prints live runtime state so we
  // can see, on a real device, why the scroll lock / sticky header misbehave:
  //  - scrollY, lock flag, and touchmove counters (block vs allow) for the lock;
  //  - the header's is-stuck class + computed position + rect.top for the sticky;
  //  - the first ancestor (if any) with transform/filter/will-change/contain,
  //    which would make position:fixed behave like position:absolute.
  function setupDebug() {
    if (!/[?&]vpvdebug/.test(location.search)) return;
    if (window.__vpvDbg) return; // already running (avoid dupes on re-init)
    window.__vpvDbg = {}; // just a dedup flag now (touchmove-lock counters removed)

    var panel = document.createElement('div');
    panel.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;' +
      'background:rgba(0,0,0,.85);color:#0f0;font:11px/1.4 monospace;padding:6px 8px;' +
      'white-space:pre-wrap;pointer-events:none;';
    document.body.appendChild(panel);

    function transformedAncestor(el) {
      var n = el && el.parentElement;
      while (n && n !== document.documentElement) {
        var cs = getComputedStyle(n);
        var hit = (cs.transform && cs.transform !== 'none') ||
          (cs.filter && cs.filter !== 'none') ||
          (cs.perspective && cs.perspective !== 'none') ||
          (cs.willChange && /transform|filter|perspective/.test(cs.willChange)) ||
          (cs.contain && /paint|layout|strict|content/.test(cs.contain));
        if (hit) {
          return (n.tagName.toLowerCase() + (n.id ? '#' + n.id : '') +
            (n.className && n.className.baseVal === undefined ? '.' + String(n.className).trim().split(/\s+/)[0] : '')) +
            ' {' + (cs.transform !== 'none' ? ' transform=' + cs.transform : '') +
            (cs.filter !== 'none' ? ' filter=' + cs.filter : '') +
            (cs.willChange !== 'auto' ? ' will-change=' + cs.willChange : '') +
            (cs.contain && cs.contain !== 'none' ? ' contain=' + cs.contain : '') + ' }';
        }
        n = n.parentElement;
      }
      return 'none';
    }

    function update() {
      var h = document.querySelector('.vpv-header');
      var lines = ['scrollY=' + Math.round(window.pageYOffset) +
        '  overlay-open=' + document.documentElement.classList.contains('vpv-overlay-open') +
        '  lockCount=' + overlayLockCount];
      if (h) {
        var cs = getComputedStyle(h);
        var r = h.getBoundingClientRect();
        lines.push('header: stuck=' + h.classList.contains('is-stuck') +
          ' pos=' + cs.position + ' cssTop=' + cs.top + ' rectTop=' + Math.round(r.top));
        var vv = window.visualViewport;
        lines.push('vv: offsetTop=' + (vv ? Math.round(vv.offsetTop) : 'n/a') +
          ' h=' + (vv ? Math.round(vv.height) : 'n/a') +
          ' innerH=' + window.innerHeight +
          ' gap=' + (vv ? Math.round(Math.max(0, window.innerHeight - vv.height)) : 'n/a'));
        var rs = getComputedStyle(document.documentElement);
        lines.push('vars: top=' + rs.getPropertyValue('--vpv-vv-top').trim());
      } else {
        lines.push('no .vpv-header');
      }
      // Open drawers: show their actual rect so we can see top/bottom alignment.
      ['VpvNavDrawer', 'CartDrawer'].forEach(function (id) {
        var el = document.getElementById(id);
        if (el && getComputedStyle(el).display !== 'none' && el.getClientRects().length) {
          var dr = el.getBoundingClientRect();
          if (dr.width > 0) {
            lines.push(id.replace('Drawer', '') + ': top=' + Math.round(dr.top) +
              ' bot=' + Math.round(dr.bottom) + ' h=' + Math.round(dr.height));
          }
        }
      });
      // Drilled submenu panel: rect bottom + scroll range. If `bot` exceeds the
      // visible height (vv h), the panel extends below the fold (too tall); if
      // scrollH≈clientH it's flush, not a scroll-range issue.
      var dp = document.querySelector('#VpvNavDrawer .vpv-nav-item.is-drilled > .vpv-nav-panel');
      if (dp) {
        var pr = dp.getBoundingClientRect();
        lines.push('panel: bot=' + Math.round(pr.bottom) + ' h=' + Math.round(pr.height) +
          ' scrollH=' + dp.scrollHeight + ' clientH=' + dp.clientHeight);
      }
      panel.textContent = lines.join('\n');
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  // Search reveal: our `.js-search-header` toggles the `.vpv-header__search`
  // container (Impulse's binding doesn't run for our custom section). The
  // predictive-search web component inside drives the results.
  function setupSearch() {
    var search = document.querySelector('.vpv-header__search');
    if (!search) return;
    var input = search.querySelector('input[type="search"], .search__input, #Search');

    function open() {
      search.removeAttribute('hidden');
      document.documentElement.classList.add('vpv-search-open');
      lockPage(); // body-pin: lock the background scroll (shared dim shows via vpv-overlay-open)
      document.dispatchEvent(new CustomEvent('predictive-search:open', { detail: { context: 'header' }, bubbles: true }));
      if (input) {
        window.requestAnimationFrame(function () { input.focus(); });
      }
    }
    function close() {
      search.setAttribute('hidden', '');
      document.documentElement.classList.remove('vpv-search-open');
      unlockPage();
      document.dispatchEvent(new CustomEvent('predictive-search:close', { bubbles: true }));
    }

    document.querySelectorAll('.js-search-header').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!search.hasAttribute('hidden')) { close(); return; }

        // When the trigger lives inside the mobile nav drawer, close the drawer
        // as search opens — one overlay at a time, rather than stacking search on
        // top of the menu (the search reveal also sits below the drawer in the
        // stacking order, so it would otherwise open hidden behind it). Close via
        // the drawer's own close button so Impulse's teardown runs and releases
        // the focus trap, leaving the search input focusable.
        var navDrawer = btn.closest('#VpvNavDrawer');
        if (navDrawer) {
          var drawerClose = navDrawer.querySelector('.js-drawer-close');
          if (drawerClose) { drawerClose.click(); }
        }
        open();

        // Impulse refocuses the drawer's opener ~500ms after close; re-assert
        // focus on the search input afterwards so focus (and the mobile keyboard)
        // land on search, not the hamburger behind the overlay.
        if (navDrawer && input) {
          window.setTimeout(function () {
            if (!search.hasAttribute('hidden')) { input.focus(); }
          }, 550);
        }
      });
    });

    // Close button(s) inside the search panel + Escape + overlay click.
    search.querySelectorAll('.btn--close-search, .js-search-close').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });

    // Chevron (.btn--search) submits the query → /search results page. Impulse
    // leaves this button inert (type="button"); .submit() does a clean GET nav
    // without firing predictive-search's submit listeners.
    var submitBtn = search.querySelector('.btn--search');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = submitBtn.closest('form');
        var q = input && input.value.trim();
        if (form && q) { form.submit(); }
        else if (input) { input.focus(); }
      });
    }
    onGlobal(document, 'keydown', function (e) {
      if (e.key === 'Escape' && !search.hasAttribute('hidden')) { close(); }
    });
    onGlobal(document, 'click', function (e) {
      if (search.hasAttribute('hidden')) return;
      if (e.target.closest('.vpv-header__search') || e.target.closest('.js-search-header')) return;
      close();
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  // Theme editor: the header section re-renders on edits, replacing our DOM and
  // dropping element-bound listeners (incl. Impulse's direct drawer-open bindings).
  // Re-init for the new nodes; teardownGlobals() inside init() prevents duplicate
  // window/document/matchMedia handlers. These two listeners bind once, for the
  // page lifetime, so they're intentionally not tracked in `teardowns`.
  function isOurSection(el) {
    return el && (el.querySelector('vpv-header') || el.querySelector('#VpvNavDrawer'));
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (isOurSection(e.target)) init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (isOurSection(e.target)) teardownGlobals();
  });
})();
